import React from 'react';

const JumpToSectionAnchor: React.FC<{
  hash: string;
  title?: string;
}> = ({ hash, title }) => {
  return <a style={{ width: 0, height: 0, padding: 0, margin: 0 }} id={hash} data-title={title} />;
};

export default JumpToSectionAnchor;
